<template>
  <page-side-bar-menu :menus="menus"></page-side-bar-menu>
</template>

<script>
import PageSideBarMenu from "@/components/PageSideBarMenu";

export default {
  name: "Sidebar",
  data() {
    return {
      menus: [
        {title: 'About Department', active: this.isActive(1), 'url': '/academics/electrical/about'},
        {title: 'Vision & Mission', active: this.isActive(2), 'url': '/academics/electrical/vision-mission'},
        {title: 'PEO, PSO, PO', active: this.isActive(3), 'url': '/academics/electrical/peo-po'},
        {title: 'Faculty', active: this.isActive(4), 'url': '/academics/electrical/faculty'},
        {title: 'Academic Calendar', active: this.isActive(5), 'url': '/academics/electrical/academic-calender'},
        {title: 'Infrastructure', active: this.isActive(6), 'url': '/academics/electrical/infrastructure'},
        {title: 'Academic Achiever', active: this.isActive(7), 'url': '/academics/electrical/academic-achievers'},
        {title: 'Result Analysis', active: this.isActive(8), 'url': '/academics/electrical/result-analysis'},
        {title: 'Achievements', active: this.isActive(9), 'url': '/academics/electrical/achievements'},
        {title: 'Students Club', active: this.isActive(10), 'url': '/academics/electrical/students-club'},
        {title: 'Social Activities', active: this.isActive(11), 'url': '/academics/electrical/social-activities'},
        {title: 'News Events', active: this.isActive(12), 'url': '/academics/electrical/news-events'},
        {title: 'Syllabus', active: this.isActive(13), 'url': '/academics/electrical/syllabus'},
        {title: 'Photo Gallery', active: this.isActive(14), 'url': '/academics/electrical/gallery'},
      ]
    }
  },
  props: {
    active: {
      default: 1,
      type: Number
    }
  },
  methods: {
    isActive(index) {
      return this.active === index;
    }
  },
  components: {
    PageSideBarMenu
  }
}
</script>

<style scoped>

</style>
